module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/pr-allotment/pr-allotment-form/pr-allotment-form.component.css
// module id = ./src/app/allocation/pr-allotment/pr-allotment-form/pr-allotment-form.component.css
// module chunks = main